import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ai-chat-card" };
const _hoisted_2 = { class: "ai-chat-card-title" };
const _hoisted_3 = { class: "ai-chat-card-description" };
import { ref } from 'vue';
import AiChatBanner from './AiChatBanner.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AiChatCard',
    props: {
        title: { default: 'Your digital assistant' },
        description: { default: 'Here when you need it – ask questions, get clear answers, or chat on WhatsApp.' },
        examples: { default: undefined }
    },
    setup(__props) {
        const banner = ref(null);
        function openChat() {
            banner.value?.openChat();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "ai-chat-card-header",
                    onClick: openChat
                }, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1)
                ]),
                _createVNode(AiChatBanner, {
                    ref_key: "banner",
                    ref: banner,
                    examples: _ctx.examples,
                    class: "ai-chat-card-banner"
                }, null, 8, ["examples"])
            ]));
        };
    }
});
